export default __webpack_public_path__ + "static/media/battery_100.2cc6d77d.svg";